import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BasePopup from "../page/components/MiniGame/components/Popup";
import bgPopup from "../assets/images/whell-type-03.png";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import imgWhellBid from "../assets/images/whell-bid.png";
import { curStateAccount, curStateHome } from "../Redux/selector";
import btnClose from "../assets/images/whell-btn-close.png";
import btnAcion from "../assets/images/whell-btn-action.png";
import iconIntro from "../assets/web-v3-images/intro-tour.png";
import iconBtnAction from "../assets/web-v3-images/btn-nodata.png";
import btnExit from "../assets/web-v3-images/icons/exits.png";
import { setReduxDataTypeIntroTour } from "../Redux/futures/home/actions";
import iconTourBid from "../assets/web-v3-images/icon-tour-bid.png";
import {
  currentDate,
  KEY_LOCAL_TOUR_COMPLETE,
  KEY_LOCAL_TYPE_USER,
  TYPE_USER,
} from "../helper/const";
import { useLocation, useNavigate } from "react-router";
import PATH from "../config/PATH";
import moment from "moment";
import UseResponsive from "@/utils/hooks/useResponsive";

export default function ModalUserFlowCases({
  backgroundImage = bgPopup,
  onClose,
  onNeverShow,
}) {
  const { typeIntroTour } = useSelector(curStateHome);
  const selectorAccount = useSelector(curStateAccount);
  const selectorHome = useSelector(curStateHome);

  const [currentProduct, setCurrentProduct] = useState([]);
  const [dueDate, setDueDate] = useState("");
  const [packageName, setPackageName] = useState("");
  const [bidTotal, setBidTotal] = useState(0);
  const [open, setOpen] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const total = selectorAccount.remainTurn?.reduce(
        (acc, pack) => acc + pack?.turn,
        0,
      );
      setBidTotal(total);
    }
  }, [selectorAccount.remainTurn]);

  useEffect(() => {
    if (selectorAccount.remainTurn.length === 1) {
      if (selectorAccount.remainTurn?.type === 1) {
        setDueDate(
          moment(selectorAccount.remainTurn[0]?.next_charge_time).format(
            "DD/MM/YYYY HH:mm:ss",
          ),
        );
      }
      if (selectorAccount.remainTurn?.type === 2) {
        setDueDate(
          moment(selectorAccount.remainTurn[0]?.reg_time)
            .add(13, "day")
            .format("DD/MM/YYYY HH:mm:ss"),
        );
      }
      setPackageName(selectorAccount.remainTurn[0]?.pack_id || "");
    }
  }, [selectorAccount.remainTurn]);

  useEffect(() => {
    if (selectorHome?.bidProduct?.length > 0) {
      setCurrentProduct(
        selectorHome.bidProduct.filter(
          (product) => new Date(product?.start_time).getTime() < currentDate,
        ),
      );
    } else {
      setCurrentProduct([]);
    }
  }, [selectorHome.bidProduct]);

  // Normal close — popup will try again next week (frequency handled by popup manager)
  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  // "Never show again" — permanent suppression
  const handleNeverShow = () => {
    setOpen(false);
    localStorage.setItem(KEY_LOCAL_TOUR_COMPLETE, "true");
    onNeverShow?.();
  };

  const dispatchBasedOnTypeActive = (typeActive, step = 1) => {
    if (selectorAccount?.userInfo) {
      dispatch(setReduxDataTypeIntroTour({ typeActive, step }));
    }
    if (location.pathname !== PATH.HOME) navigate(PATH.HOME);
  };

  const handleAction = () => {
    if (+typeIntroTour?.typeActive === TYPE_USER.newNoPackage) {
      dispatchBasedOnTypeActive(TYPE_USER.newNoPackage);
    }
    if (+typeIntroTour?.typeActive === TYPE_USER.newPackage) {
      dispatchBasedOnTypeActive(TYPE_USER.newPackage);
    }
    if (
      +typeIntroTour?.typeActive === TYPE_USER.firstLoginAfterRegistered7Days
    ) {
      dispatchBasedOnTypeActive(TYPE_USER.firstLoginAfterRegistered7Days);
    }
    if (
      +typeIntroTour?.typeActive ===
      TYPE_USER.firstLoginWithinRegistered2To6Days
    ) {
      dispatchBasedOnTypeActive(TYPE_USER.firstLoginWithinRegistered2To6Days);
    }
    setOpen(false);
    onClose?.();
  };

  if (+typeIntroTour?.step === 0 && selectorAccount?.userInfo) {
    const bodyModal = () => {
      if (+typeIntroTour?.typeActive === TYPE_USER.newNoPackage) {
        return (
          <>
            <img
              src={btnExit}
              alt=""
              onClick={handleNeverShow}
              className="absolute top-[162px] right-[35px] w-[53px] btn-click-active"
            />

            <div className="main-body">
              <p
                className={`[word-break:break-word] font-['Inter:Medium',sans-serif] font-medium leading-[normal]  not-italic text-[#854a0e] ${i18n.language === "my" ? "text-[14px]" : "text-[20px]"} text-center  w-[80%]`}
              >
                {t("let_take_a_quick_tour_to_discover_the_main_features")}
              </p>
              <div className="container-icon-intro">
                <img src={iconIntro} alt="" className="icon-intro" />
                <div
                  className="icon-btn-actions btn-click-active"
                  onClick={handleAction}
                >
                  <img
                    src={iconBtnAction}
                    alt=""
                    style={{
                      cursor: "pointer",
                      height: "40px",
                      width: "195px",
                      maxWidth: "195px",
                    }}
                    className={`${i18n.language === "my" ? "start-tour_my" : ""}`}
                  />
                  <div
                    className={`start-tour ${i18n.language === "my" ? "start-tour_text_my" : ""}`}
                  >
                    {t("start_tour")}
                  </div>
                </div>
                <div className="[word-break:break-word] btn-click-active font-['Inter:Extra_Bold',sans-serif] font-extrabold justify-center leading-[0] not-italic relative shrink-0 text-[#713b12] text-[20px] text-center tracking-[0.36px] relative z-10">
                  <p
                    className={`leading-[normal] ${i18n.language === "my" ? "start-tour_skip" : ""}`}
                    onClick={handleNeverShow}
                    style={{
                      cursor: "pointer",
                      paddingTop: "15%",
                      width: "max-content",
                      margin: "0 auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {t("user_guide.skip")}
                  </p>
                </div>
              </div>
            </div>
          </>
        );
      }
      if (+typeIntroTour?.typeActive === TYPE_USER.newPackage) {
        return (
          <>
            <img
              src={btnExit}
              alt=""
              onClick={handleNeverShow}
              className="absolute top-[162px] right-[35px] w-[53px] btn-click-active"
            />

            <div className="main-body">
              <div
                className={`container-icon-intro  w-[70%] flex flex-col ${i18n.language === "my" ? "gap-[4px]" : "gap-[30px]"} `}
                style={{ top: "-45px" }}
              >
                <img
                  src={iconTourBid}
                  alt=""
                  className="icon-intro"
                  style={{ height: "210px", width: "auto" }}
                />
                <p
                  className={` [word-break:break-word] font-['Inter:Medium',sans-serif] font-medium leading-[normal]  not-italic text-[#854a0e]  text-center ${i18n.language === "my" ? "text-[14px]" : "text-[16px]"}`}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: t("claim_1_free").replace(
                        "[product_name]",
                        currentProduct[0]?.product_name,
                      ),
                    }}
                  />
                </p>

                <div
                  className="relative mx-auto flex justify-center btn-click-active"
                  onClick={handleAction}
                >
                  <img
                    src={iconBtnAction}
                    alt=""
                    style={{
                      cursor: "pointer",
                      height: "50px",
                      width: "195px",
                      maxWidth: "195px",
                    }}
                  />
                  <div className="start-tour">{t("claim")}</div>
                </div>
              </div>
            </div>
          </>
        );
      }
      // if (+typeIntroTour.typeActive === TYPE_USER.firstLoginAfterRegistered7Days) {
      //   return (
      //     <>
      //       <div className='main-body'>
      //         <div className='content-whell-3'>
      //           <div>
      //             <span className='content-bold'>
      //               {t("user_guide.welcome_to_shwe_deal")}
      //             </span>
      //           </div>
      //           <div>
      //             <span>
      //               {t("user_guide.you_have_received_free_bids").replace("_X_", bidTotal)}
      //             </span>
      //             <span>{t("user_guide.the_winner")}</span>
      //             <span
      //               dangerouslySetInnerHTML={{
      //                 __html: t("user_guide.try_your_luck").replace(
      //                   "[product_name]",
      //                   currentProduct[0]?.product_name
      //                 ),
      //               }}
      //             />
      //           </div>
      //         </div>
      //       </div>
      //       <div className='footer-whell-3' onClick={handleAction}>
      //         <img src={btnAcion} alt='' />
      //         <div className='content-footer-whell'>ခုလေလံဆွဲမည်</div>
      //       </div>
      //     </>
      //   );
      // }
      // if (+typeIntroTour.typeActive === TYPE_USER.firstLoginWithinRegistered2To6Days) {
      //   return (
      //     <>
      //       <div className='main-body'>
      //         <div className='content-whell-3'>
      //           <div>
      //             <span className='content-bold'>
      //               {t("user_guide.welcome_to_shwe_deal")}
      //             </span>
      //           </div>
      //           <div>
      //             <span>{t("user_guide.you_have_received_all_7_free_turns")}</span>
      //             <span>{t("user_guide.the_winner")}</span>
      //             <span
      //               dangerouslySetInnerHTML={{
      //                 __html: t("user_guide.try_your_luck").replace(
      //                   "[product_name]",
      //                   currentProduct[0]?.product_name
      //                 ),
      //               }}
      //             />
      //           </div>
      //         </div>
      //       </div>
      //       <div className='footer-whell-3' onClick={handleAction}>
      //         <img src={btnAcion} alt='' />
      //         <div className='content-footer-whell'>ခုလေလံဆွဲမည်</div>
      //       </div>
      //     </>
      //   );
      // }
    };

    return (
      <BasePopup
        className={`popup-invite position-relative`}
        isMaxWidth={true}
        open={open}
        onCancel={handleClose}
      >
        <UseResponsive
          height={715}
          width={496}
          transformOrigin="center left"
          isHiddenBg
        >
          <Div>
            <div className="position-relative">
              <div
                className="container-btn-close-whell-3 scale-hover-item"
                onClick={handleClose}
              >
                {/* <img src={btnClose} alt='' /> */}
              </div>
              <div className="container-whell-bid">
                <div className="position-relative">
                  <div
                    className={`popup-type-3-whell ${
                      +bidTotal > 99
                        ? "big-3-whell"
                        : +bidTotal < 10
                          ? "small-3-whell"
                          : ""
                    }`}
                  >
                    {bidTotal}
                  </div>
                </div>
              </div>
              {/* <img src={iconIntro} alt='' className='icon-intro' /> */}
              <img src={backgroundImage} alt="" className="bg-popup-intro" />
              {bodyModal()}
            </div>
            {/* <div className="never-show-container">
            <span onClick={handleNeverShow}>နောက်ထပ် မပြတော့ပါ</span>
          </div> */}
          </Div>
        </UseResponsive>
      </BasePopup>
    );
  }

  return <></>;
}

const Div = styled.div`
  .container-icon-intro {
    position: absolute;
    height: 285px;
    top: 25px;
  }

  .icon-intro {
    height: 285px;
  }

  .icon-btn-actions {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11;
  }

  .start-tour {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    font-weight: 600;
    color: #fff;
  }

  .never-show-container {
    text-align: center;
    margin-top: 8px;
    padding-bottom: 4px;

    span {
      color: rgba(255, 255, 255, 0.65);
      font-size: 12px;
      cursor: pointer;
      text-decoration: underline;
      transition: color 0.2s;

      &:hover {
        color: rgba(255, 255, 255, 0.9);
      }
    }
  }

  .footer-whell-3 {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .content-footer-whell {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 18px;
    color: #e14a09;
    font-weight: 600;
    font-size: 15px;
    width: 100%;
    text-align: center;
    cursor: pointer;
  }

  .popup-type-3-whell {
    position: absolute;
    top: 25px;
    left: 34px;
    color: white;
    font-weight: 500;
  }

  .big-3-whell {
    font-size: 10px;
    top: 28px;
    left: 33.5px;
  }

  .small-3-whell {
    left: 38px;
  }

  .container-whell-bid {
    position: absolute;
    top: -82px;
    left: 50%;
    transform: translateX(-50%);
  }

  .content-main {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    font-weight: 600;
  }

  .rule-mini-close {
    position: absolute;
    z-index: 100;
    right: -9px;
    top: 15px;
  }

  .footer-content-intro {
    padding: 5px 20px;
    text-align: center;
    font-size: 14px;
    color: #64310b;
    font-style: italic;
    line-height: 20px;
  }

  .content-whell-3 {
    font-size: 16px;
    font-style: italic;
    text-align: center;
    color: #481d1d;

    & .content-bold {
      font-weight: bold;
    }
  }

  .img-container {
    position: relative;
  }

  .content-btn {
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    cursor: pointer;
  }

  .container-btn-close-whell-3 {
    position: absolute;
    z-index: 3;
    top: 7px;
    right: 7px;
    cursor: pointer;
  }

  .bg-btn {
    height: 65px;
    width: 82%;
    text-align: center;
    margin: 0 auto;
  }

  .bg-popup-intro {
    max-width: 480px;
    max-height: 715px;
    min-height: 688px !important;
  }

  .img-body {
    margin-left: -10px;
  }

  .position-relative {
    position: relative;
    width: max-content;
    margin: 0 auto;
  }

  .main-body {
    position: absolute;
    z-index: 2;
    top: 129px;
    width: 100%;
    padding: 0 6%;
    margin-top: 26%;
    display: flex;
    justify-content: center;
  }

  .mini-game-text-header {
    text-align: center;
    div {
      line-height: 21px;
      font-weight: 500;
    }
  }

  .start-tour_my {
    width: 265px !important;
    max-width: 265px !important;
    height: 50px !important;
  }

  .start-tour_text_my {
    font-size: 14px !important;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .start-tour_skip {
    padding-top: 17% !important;
  }

  /* @media (min-width: 992px) {
    .content-btn:hover {
      img {
        scale: 1.03;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 768px) {
    .content-whell-3 {
      font-size: 14px;
    }
  }

  @media (max-width: 525px) {
    .bg-popup-intro {
      max-width: 100%;
    }
    .position-relative {
      position: relative;
      width: auto;
      margin: 0 auto;
    }
    .content-whell-3 {
      font-size: 13px;
    }
    .content-footer-whell {
      top: 16px;
    }
  } */
`;
